import { forwardRef } from 'react';
import { cn } from '@/shared/lib/utils';
import { type FormFieldSize, formFieldSizeVariants } from '../helpers/field-size';

type TextareaProps = React.ComponentProps<'textarea'> & {
  size?: FormFieldSize;
};

/**
 * Textarea コンポーネント
 *
 * 基本的な複数行テキスト入力フィールド。
 * フォーム外でも単体で使用可能。
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, size = 'sm', ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'input-field',
          'flex h-auto w-full',
          formFieldSizeVariants({ size }),
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
